// Seeded Zufall für die Kampfsimulation (X2): gleicher Seed, gleicher Kampf.
// In src/sim ist Math.random verboten (tests/architecture.test.ts), Zufall läuft nur hierüber.
// Verfahren: mulberry32, klein, schnell und für Spielzwecke gut genug.

export type Rng = {
  /** Zahl in [0, 1) */
  next(): number;
  /** Ganze Zahl in [min, max] */
  int(min: number, max: number): number;
  /** Innerer Zustand, damit ein Run gespeichert und genau dort fortgesetzt werden kann */
  state(): number;
};

export function createRng(seed: number): Rng {
  let state = seed >>> 0;
  const next = (): number => {
    state = (state + 0x6d2b79f5) >>> 0;
    let t = state;
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
  return {
    next,
    int: (min, max) => min + Math.floor(next() * (max - min + 1)),
    state: () => state,
  };
}
